import { useContext } from 'react';

import {
  Box,
  Button,
  Flex,
  Icon,
  IconName
} from '../../../../v2/components/atoms';
import { BudgetScreenContext } from '../../contexts/budget-screen-context';
import { ProductScreenContext } from '../../contexts/product-screen-context';

interface HeaderProps {
  children: React.ReactNode;
}

export function ProductHeader({ children }: HeaderProps): JSX.Element {
  const context = useContext(ProductScreenContext);
  return (
    <Box
      as="header"
      p="space_unit.x4"
      mb="space_unit.x2"
      sx={{ '&>h4': { mb: 'space_unit.x2' } }}
      backgroundColor={context?.productScreen?.screen?.color ?? 'transparent'}
    >
      {context?.productScreen?.screen?.showBudgetCombination !== true && (
        <Flex pb="space_unit.x1">
          <Button
            onClick={context?.productScreen?.screen?.goBack}
            leftIcon={
              <Icon w="18px" h="18px" color="black" name={IconName.ArrowBack} />
            }
            variant="tertiary"
            p="0"
          />
        </Flex>
      )}
      {children}
    </Box>
  );
}

export function BudgetHeader({ children }: HeaderProps): JSX.Element {
  const context = useContext(BudgetScreenContext);
  return (
    <Box
      as="header"
      backgroundColor="palette_blue.0"
      p="space_unit.x4"
      mb="space_unit.x2"
      sx={{ '&>h4': { mb: 'space_unit.x2' } }}
    >
      <Flex pb="space_unit.x1">
        <Button
          onClick={context?.budgetScreen?.screen?.goBack}
          leftIcon={
            <Icon w="18px" h="18px" color="black" name={IconName.ArrowBack} />
          }
          variant="tertiary"
          p="0"
        />
      </Flex>

      {children}
    </Box>
  );
}
